import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription, Observable } from "rxjs";
import { switchMap } from "rxjs/operators";
import { OrganizationFormComponent } from './components/organization-form.component';

import { AuthService } from '../../../services/auth.service';
import { LoaderService } from '../../services/loader.service';
import { OrganizationService } from '../../services/organization.service';
import { SubHeaderService } from '../../../core/services/sub-header.service';

import { Organization } from '../../models/organization.model';
import { SubHeader } from '../../../core/models/sub-header.model';
import { LunaClaimTypes, LunaClaimValues } from '../../../models/user-identity.model';
import { DynamicDialogService } from "../../../core/services/dynamic-dialog.service";
import { Dialog, DialogButton } from "../../../core/models/dialog.model";

@Component({
    selector: 'organization-edit',
    templateUrl: './organization-edit.component.html',
    standalone: false
})
export class OrganizationEditComponent implements OnInit, OnDestroy {

    displayDeptLabel: boolean = this.authService.User.isInternal ? true : false;
    organization: Organization;
    parentOrganization: Organization;

    subHeader: SubHeader;
    subscription: Subscription = new Subscription();
    successDialog: Dialog = new Dialog("Organization has been successfully updated.", [new DialogButton("OK", true, () => this.goHome())]);

    canEditOrg: boolean = false;

    @ViewChild(OrganizationFormComponent, { static: true }) public _form: OrganizationFormComponent;

    constructor(
        public route: ActivatedRoute,
        public authService: AuthService,
        public router: Router,
        public subHeaderService: SubHeaderService,
        public service: OrganizationService,
        public loader: LoaderService,
        private dialog: DynamicDialogService
    ) {
        this.canEditOrg = this.authService.User.allClaims.filter(a => a.type == LunaClaimTypes.System && a.value == LunaClaimValues.CanEditOrganization).length > 0;
        let subHeaderButtons: any[] = [];

        subHeaderButtons.push({ name: "Cancel", method: () => this.cancel() });
        if (this.canEditOrg)
            subHeaderButtons.push({ name: "Save", method: () => this.save() });
        this.subHeader = new SubHeader({
            title: "Manage Organization",
            buttons: subHeaderButtons
        });
    }

    ngOnInit() {
        this.loader.toggleLoader(false);
        this.subHeaderService.updateSubHeader(this.subHeader);
        this.organization = this.route.snapshot.data.organization;

        //If this org has a parent one, fetch it
        if (this.organization.isDbaName && this.organization.parentOrganizationId !== undefined
            && this.organization.parentOrganizationId !== null && this.organization.parentOrganizationId !== "") {
            this.service.getOrganization(this.organization.parentOrganizationId).subscribe(fetchedParentOrganization => {
                if (fetchedParentOrganization)
                    this.parentOrganization = fetchedParentOrganization;
            })
        }

        if (!this.organization.departments) this.organization.departments = [];
    }

    ngOnDestroy() {
        if (this.subscription != null) this.subscription.unsubscribe();
    }

    cancel(): void {
        this.router.navigate(['/home']);
    }

    goHome(): void {
        this.router.navigate(['/home']);
    }

    save(): void {
        if (!this._form.orgForm.invalid/*.isValid*/) {
            this.loader.toggleLoader(true);

            let obs$: Observable<Organization> = this.service.save(this.organization);

            if (this.organization.isDbaName) {
                obs$ = obs$.pipe(
                    switchMap((response: Organization) => {
                        return this.service.save(this.parentOrganization);
                    })
                );
            }

            this.subscription = obs$.subscribe(
                () => {
                    this.loader.toggleLoader(false);
                    this.successDialog.toggleDialog(true);
                    this.dialog.updateDialog(this.successDialog);
                },
                (error) => {
                    console.error(error);
                    this.loader.toggleLoader(false);
                    this.dialog.showError();
                }
            );
        }
    }

}
